import { render, staticRenderFns } from "./mobile-tickets-list.vue?vue&type=template&id=c84234f0&scoped=true"
import script from "./mobile-tickets-list.vue?vue&type=script&lang=js"
export * from "./mobile-tickets-list.vue?vue&type=script&lang=js"
import style0 from "./mobile-tickets-list.vue?vue&type=style&index=0&id=c84234f0&prod&lang=scss"
import style1 from "./mobile-tickets-list.vue?vue&type=style&index=1&id=c84234f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84234f0",
  null
  
)

export default component.exports